export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 170,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'contractCarrierNo',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    title: '合同编号',
    sortable: true,
    sortType: 'String',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'contractCarrierName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 160,
    title: '合同名称',
    sortable: true,
    sortType: 'String',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'carrierShortName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 130,
    title: '承运商',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'transportModeName',
    align: 'center',
    minWidth: 80,
    title: '运输模式',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'chargeUnitName',
    align: 'center',
    minWidth: 80,
    title: '计费单位',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'custShortName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 130,
    title: '所属客户',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orgName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: '组织机构',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'startDate',
    align: 'center',
    minWidth: 100,
    title: '开始日期',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'endDate',
    align: 'center',
    minWidth: 100,
    title: '结束日期',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  // {
  //   field: 'signCustPerson',
  //   align: 'center',
  //   minWidth: 90,
  //   title: '甲方签署人',
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  // },
  // {
  //   field: 'signOrgPerson',
  //   align: 'center',
  //   minWidth: 90,
  //   title: '乙方签署人',
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  // },
  // {
  //   field: 'contractCarrierManagePerson',
  //   align: 'center',
  //   minWidth: 90,
  //   title: '合同保管人',
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  // },
  // {
  //   field: 'signDate',
  //   align: 'center',
  //   minWidth: 100,
  //   title: '签订日期',
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  // },
  {
    align: 'center',
    width: 100,
    title: '状态',
    slots: { default: 'status' },
  },
  {
    field: 'createTime',
    title: '创建时间',
    headerAlign: 'center',
    align: 'left',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createByName',
    title: '创建人',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    title: '修改时间',
    headerAlign: 'center',
    align: 'left',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    title: '修改人',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
